/* eslint-disable ember/no-computed-properties-in-native-classes */
import { action, computed } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type dayjs from 'dayjs';
import type HotelPricingManagerDetailRoute from 'lumen/routes/hotel/pricing-manager/detail';
import type { ModelFrom } from 'lumen/utils/routes';

const FILTER_BAR_HEIGHT = 35;

export interface GeneralDayDetailTabsTabDayDetailBaseSignature {
  Args: {
    params: {
      dayMoment: dayjs.Dayjs;
      height: number;
      model: ModelFrom<HotelPricingManagerDetailRoute>;
    };
  };
}

export default class GeneralDayDetailTabsTabDayDetailBase<
  T extends GeneralDayDetailTabsTabDayDetailBaseSignature,
> extends Component<T> {
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];

  @tracked bannerHeight = 0;

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get correctedHeight() {
    return this.args.params.height - FILTER_BAR_HEIGHT - this.bannerHeight;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isCurrentOrFutureDay() {
    return this.args.params.dayMoment.isSameOrAfter(
      this.hotelAndMarketService.getLocalTime(),
      'day',
    );
  }

  @computed('args.params.model')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get model() {
    return this.args.params?.model;
  }

  @computed('model.periods.[]')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get sortedPeriods() {
    return this.model.periods.slice();
  }

  @action setBannerHeight(element: HTMLElement | null): void {
    this.bannerHeight = element?.offsetHeight ?? 0;
  }
}
